import { UPP_SB_PAYMENT_COMPONENTS } from '#src/clientState/ab/featureNames';
import { createFeature } from '@edreamsodigeo/frontend-core';
import React, { createContext, useContext } from 'react';

interface ProviderProps {
  children: React.ReactNode;
}

const PaymentComponentsAB = createContext<boolean>(false);

export const PaymentComponentsDisabled: React.FC<ProviderProps> = ({
  children,
}) => {
  return (
    <PaymentComponentsAB.Provider value={false}>
      {children}
    </PaymentComponentsAB.Provider>
  );
};

export const PaymentComponentsEnabled: React.FC<ProviderProps> = ({
  children,
}) => {
  return (
    <PaymentComponentsAB.Provider value={true}>
      {children}
    </PaymentComponentsAB.Provider>
  );
};

export const usePaymentCompontentsAB = () => useContext(PaymentComponentsAB);

export const PaymentComponentsABProvider = createFeature({
  name: UPP_SB_PAYMENT_COMPONENTS,
  variations: [PaymentComponentsDisabled, PaymentComponentsEnabled],
});
